const environment = {
    API_HOST: process.env.VUE_APP_API_HOST,
    appName: "piRender",
};

export const socketIO = {
    url: process.env.VUE_APP_SOCKET_IO_URL,
    IRENDER_CMD_ADDUSER: "add user",
};

export const socketIOEvents = {
    url: process.env.VUE_APP_SOCKET_EVENT_URL
};


/*eslint-disable */
export const regex = {
    email: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    onlyDigit: /^[0-9]+$/,
    noSpecialChar: /^[A-Za-z0-9]+$/,
    phone: /^[+0-9]+$/,
    noSpace: /^\S*$/u,
    password: /^[a-zA-Z0-9!@#$%^&*]{6,50}$/,
    passwordAtLeastUppercaseChar: /^(?=.*[A-Z])(.{6,50})$/,
    passwordAtLeastLowercaseChar: /^(?=.*[a-z])(.{6,50})$/,
    passwordAtLeastNumber: /^(?=.*[0-9])(.{6,50})$/,
    passwordAtLeastSpecialChar: /^(?=.*[!@#$%^&*])(.{6,50})$/,
    passwordAtNoSpace: /^(?=.*[!@#$%^&*])(.{6,50})$/,
};

export const SOCKET_TOPIC_AND_COMAND = {
    SOCKET_TOPIC: "irender.rental.update",
    SOCKET_COMMAND_NOTIFICATION: "ServerPushNotification",
    SOCKET_COMMAND_GOUHUB: ""
}

export const EXECUTE_RESULT = {
    SUCCESS: 0,
    ERROR: 1,
};

export const ERROR_SYSTEM_MESSAGE = {
    error404: 'Request failed with status code 404',
    error500: 'Network Error',
};

export const USER_REQUEST_TYPE = {
    NOTIFY_MACHINE_AVAILABLE: 1,
    FIXED_RENTAL_REQUEST: 2,
};

export const GPURENTAL_STATUS_CODE = {

    //Login cookie
    LoginCookie_UserIdNotFound: -10000,
    LoginCookie_UserInformationView_Failed: -10001, //User_UserInformationViewByEmail
    LoginCookie_UserInformationView_NoData: -10002,
    LoginCookie_CheckAccess_Failed: -10005, //User_CheckAccess

    LoginCookie_Success: 10000,
    LoginCookie_Exception: 10001,
    LoginCookie_GetByUsername: 10002,
    LoginCookie_GetByEmailAdress: 10003,
    LoginCookie_UserNotExist: 10004,
    LoginCookie_NonActivate: 10005,
    LoginCookie_WrongPassword: 10006,
    LoginCookie_UserBlocked: 10007,
    LoginCookie_UserNoStatus: 10008,
    LoginCookie_RecaptchaVerifyFailed: 10009,
    LoginCookie_CheckingTwoFactorAuthentication: 10012,
    LoginCookie_TwoFactorAuthPinInValid: 10013,
    LoginCookie_UserDisabled: 10014,

    //Login token
    LoginToken_UserIdNotFound: -10100,
    LoginToken_UserInformationView_Failed: -10101, //User_UserInformationViewByEmail
    LoginToken_UserInformationView_NoData: -10102,
    LoginToken_CheckAccess_Failed: -10105, //User_CheckAccess

    LoginToken_Success: 10100,
    LoginToken_Exception: 10101,
    LoginToken_GetByUsername: 10102,
    LoginToken_GetByEmailAdress: 10103,
    LoginToken_UserNotExist: 10104,
    LoginToken_NonActivate: 10105,
    LoginToken_WrongPassword: 10106,
    LoginToken_UserBlocked: 10107,
    LoginToken_UserNoStatus: 10108,
    LoginToken_ValidateToken: 10109,

    //Register
    Register_UserIdNotFound: -20000,
    Register_UserInformationView_Failed: -20001, //User_UserInformationViewByEmail
    Register_UserInformationView_NoData: -20002,
    Register_CheckAccess_Failed: -20005, //User_CheckAccess

    Register_Success: 20000,
    Register_Exception: 20001,
    Register_GetByUsername: 20002,
    Register_GetByEmailAdress: 20003,
    Register_UsernameExist: 20004,
    Register_EmailExist: 20005,
    Register_Register_Failed: 20006,
    Register_CheckAccountExist_Failed: 20007,

    //Resent active email 
    ResendActiveEmail_UserIdNotFound: -30000,
    ResendActiveEmail_UserInformationView_Failed: -30001, //User_UserInformationViewByEmail
    ResendActiveEmail_UserInformationView_NoData: -30002,
    ResendActiveEmail_CheckAccess_Failed: -30005, //User_CheckAccess

    ResendActiveEmail_Success: 30000,
    ResendActiveEmail_Exception: 30001,
    ResendActiveEmail_GetByEmailAdress: 30002,
    ResendActiveEmail_EmailNotExist: 30003,
    ResendActiveEmail_AccountActivated: 30004,
    ResendActiveEmail_SendMailActiveCode: 30005,

    ResendActiveEmail_NoAccess: 30098,

    //Forgot password
    ForgotPassword_UserIdNotFound: -40000,
    ForgotPassword_UserInformationView_Failed: -40001, //User_UserInformationViewByEmail
    ForgotPassword_UserInformationView_NoData: -40002,
    ForgotPassword_CheckAccess_Failed: -40005, //User_CheckAccess

    ForgotPassword_Success: 40000,
    ForgotPassword_Exception: 40001,
    ForgotPassword_GetByEmailAdress: 40002,
    ForgotPassword_EmailNotExist: 40003,
    ForgotPassword_GetByUserId: 40004,
    ForgotPassword_Insert: 40005,
    ForgotPassword_Update: 40006,
    ForgotPassword_UpdateToken: 40007,

    ForgotPassword_RecaptchaVerifyFailed: 40097,
    ForgotPassword_NoAccess: 40098,

    //Change password
    ChangePassword_UserIdNotFound: -50000,
    ChangePassword_UserInformationView_Failed: -50001, //User_UserInformationViewByUserId
    ChangePassword_UserInformationView_NoData: -50002,
    ChangePassword_CheckAccess_Failed: -50005, //User_CheckAccess

    ChangePassword_Success: 50000,
    ChangePassword_Exception: 50001,
    ChangePassword_UserNotExist: 50002,
    ChangePassword_OldPasswordInvalid: 50003,

    ChangePassword_NoAccess: 50098,

    //Update profile
    UpdateProfile_UserIdNotFound: -60000,
    UpdateProfile_UserInformationView_Failed: -60001, //User_UserInformationViewByUserId
    UpdateProfile_UserInformationView_NoData: -60002,
    UpdateProfile_CheckAccess_Failed: -60005, //User_CheckAccess

    UpdateProfile_Success: 60000,
    UpdateProfile_Exception: 60001,
    UpdateProfile_UpdateProfile_Failed: 60002,

    UpdateProfile_NoAccess: 60098,

    //Logout
    Logout_UserIdNotFound: -70000,
    Logout_UserInformationView_Failed: -70001, //User_UserInformationViewByUserId
    Logout_UserInformationView_NoData: -70002,
    Logout_CheckAccess_Failed: -70005, //User_CheckAccess

    Logout_Success: 70000,
    Logout_Exception: 70001,
    Logout_UserNotExist: 70002,

    //Create machine
    CreateImage_UserIdNotFound: -80000,
    CreateImage_UserInformationView_Failed: -80001, //User_UserInformationViewByUserId
    CreateImage_UserInformationView_NoData: -80002,
    CreateImage_CheckAccess_Failed: -80005, //User_CheckAccess

    CreateImage_Success: 80000,
    CreateImage_Exception: 80001,
    CreateImage_UserNotExist: 80002,
    CreateImage_BalanceNotEnough: 80003,

    CreateImage_GetVMMachimeByUserId: 80004,
    CreateImage_GetAll: 80005,
    CreateImage_GetAll_NoData: 80006,
    CreateImage_ServicePackNotFound: 80007,
    CreateImage_GetUserConfiguration: 80008,
    CreateImage_GetUserConfiguration_NoData: 80009,
    CreateImage_UserLevelNotMatch: 80010,

    CreateImage_LimitedImage: 80011,
    CreateImage_LimitedMinimumBalance: 80012,
    CreateImage_MachineInsert_Failed: 80013,
    CreateImage_UserMachineInsert_Failed: 80014,
    CreateImage_GetImageThreshold: 80015,
    CreateImage_GetImageThreshold_NoDate: 80016,
    CreateImage_LimitedMinimumTotalRecharge: 80017,
    CreateImage_PackageInformationView_Failed: 80018,
    CreateImage_PackageInformationView_NoData: 80019,

    CreateImage_FixedRental_Success: 80100,
    CreateImage_FixedRental_InsertBilling: 80100,

    CreateImage_NoAccess: 80098,

    //Boot machine
    BootMachine_UserIdNotFound: -90000,
    BootMachine_UserInformationView_Failed: -90001, //User_UserInformationViewByUserId
    BootMachine_UserInformationView_NoData: -90002,
    BootMachine_MachineInformationView_Failed: -90003, //VmMachine_MachineInformationView
    BootMachine_MachineInformationView_NoData: -90004,
    BootMachine_CheckAccess_Failed: -90005, //User_CheckAccess

    BootMachine_Success: 90000,
    BootMachine_Exception: 90001,
    BootMachine_UserNotExist: 90002,
    BootMachine_UserAndMachineNotMatch: 90003,
    BootMachine_CheckServicePackAvailability_Failed: 90004,
    BootMachine_NoMachineAvailability: 90005,
    BootMachine_BalanceNotEnough: 90006,
    BootMachine_LimitedMinimumTotalRecharge: 90007,
    BootMachine_LimitedMinimumBalance: 90008,
    BootMachine_BootMachine_Failed: 90009,
    BootMachine_FixedRentalTooEarly: 90010,
    BootMachine_FixedRentalExpired: 90011,
    BootMachine_CheckAccess: 90012,

    BootMachine_NoAccess: 90098,
    BootMachine_InvalidStatus: 90099,

    //Shutdown machine
    ShutdownMachine_UserIdNotFound: -100000,
    ShutdownMachine_UserInformationView_Failed: -100001, //User_UserInformationViewByUserId
    ShutdownMachine_UserInformationView_NoData: -100002,
    ShutdownMachine_MachineInformationView_Failed: -100003, //VmMachine_MachineInformationView
    ShutdownMachine_MachineInformationView_NoData: -100004,
    ShutdownMachine_CheckAccess_Failed: -100005, //User_CheckAccess

    ShutdownMachine_Success: 100000,
    ShutdownMachine_Exception: 100001,
    ShutdownMachine_UserNotExist: 100002,
    ShutdownMachine_UserAndMachineNotMatch: 100003,
    ShutdownMachine_ShutdownMachine_Failed: 100004,

    ShutdownMachine_NoAccess: 100098,
    ShutdownMachine_InvalidStatus: 100099,

    //Change service package
    ChangePackageMachine_UserIdNotFound: -110000,
    ChangePackageMachine_UserInformationView_Failed: -110001, //User_UserInformationViewByUserId
    ChangePackageMachine_UserInformationView_NoData: -110002,
    ChangePackageMachine_MachineInformationView_Failed: -110003, //VmMachine_MachineInformationView
    ChangePackageMachine_MachineInformationView_NoData: -110004,
    ChangePackageMachine_CheckAccess_Failed: -110005, //User_CheckAccess

    ChangePackageMachine_Success: 110000,
    ChangePackageMachine_Exception: 110001,
    ChangePackageMachine_UserNotExist: 110002,
    ChangePackageMachine_UserAndMachineNotMatch: 110003,
    ChangePackageMachine_ChangePackageMachine_Failed: 110004,
    ChangePackageMachine_FixedRental: 110005,

    ChangePackageMachine_NoAccess: 110098,
    ChangePackageMachine_InvalidStatus: 110099,

    //Clone image
    CloneImage_UserIdNotFound: -120000,
    CloneImage_UserInformationView_Failed: -120001, //User_UserInformationViewByUserId
    CloneImage_UserInformationView_NoData: -120002,
    CloneImage_MachineInformationView_Failed: -120003, //VmMachine_MachineInformationView
    CloneImage_MachineInformationView_NoData: -120004,
    CloneImage_CheckAccess_Failed: -120005, //User_CheckAccess

    CloneImage_Success: 120000,
    CloneImage_Exception: 120001,
    CloneImage_UserNotExist: 120002,
    CloneImage_UserAndMachineNotMatch: 120003,
    CloneImage_BalanceNotEnough: 120004,
    CloneImage_TotalRechargeNotEnough: 120005,
    CloneImage_GetVMMachimeByUserId: 120006,
    CloneImage_GetAll: 120007,
    CloneImage_GetAll_NoData: 120008,
    CloneImage_ServicePackNotFound: 120009,
    CloneImage_GetUserConfiguration: 120010,
    CloneImage_GetUserConfiguration_NoData: 120011,
    CloneImage_UserLevelNotMatch: 120012,
    CloneImage_LimitedImage: 120013,
    CloneImage_LimitedMinimumBalance: 120014,
    CloneImage_CloneImage_Failed: 120015,

    CloneImage_NoAccess: 120098,
    CloneImage_InvalidStatus: 120099,

    //Download remote desktop
    DownloadRemoteDesktop_UserIdNotFound: -130000,
    DownloadRemoteDesktop_UserInformationView_Failed: -130001, //User_UserInformationViewByUserId
    DownloadRemoteDesktop_UserInformationView_NoData: -130002,
    DownloadRemoteDesktop_MachineInformationView_Failed: -130003, //VmMachine_MachineInformationView
    DownloadRemoteDesktop_MachineInformationView_NoData: -130004,
    DownloadRemoteDesktop_CheckAccess_Failed: -130005, //User_CheckAccess

    DownloadRemoteDesktop_Success: 130000,
    DownloadRemoteDesktop_Exception: 130001,
    DownloadRemoteDesktop_UserAndMachineNotMatch: 130003,
    DownloadRemoteDesktop_TemplateNotExist: 130004,

    DownloadRemoteDesktop_NoAccess: 130098,
    DownloadRemoteDesktop_InvalidStatus: 130099,

    //Rename image
    RenameImage_UserIdNotFound: -140000,
    RenameImage_UserInformationView_Failed: -140001, //User_UserInformationViewByUserId
    RenameImage_UserInformationView_NoData: -140002,
    RenameImage_MachineInformationView_Failed: -140003, //VmMachine_MachineInformationView
    RenameImage_MachineInformationView_NoData: -140004,
    RenameImage_CheckAccess_Failed: -140005, //User_CheckAccess

    RenameImage_Success: 140000,
    RenameImage_Exception: 140001,
    RenameImage_UserNotExist: 140002,
    RenameImage_UserAndMachineNotMatch: 140003,
    RenameImage_RenameMachine_Failed: 140004,

    RenameImage_NoAccess: 140098,

    //Remove image
    RemoveImage_UserIdNotFound: -150000,
    RemoveImage_UserInformationView_Failed: -150001, //User_UserInformationViewByUserId
    RemoveImage_UserInformationView_NoData: -150002,
    RemoveImage_MachineInformationView_Failed: -150003, //VmMachine_MachineInformationView
    RemoveImage_MachineInformationView_NoData: -150004,
    RemoveImage_CheckAccess_Failed: -150005, //User_CheckAccess

    RemoveImage_Success: 150000,
    RemoveImage_Exception: 150001,
    RemoveImage_UserNotExist: 150002,
    RemoveImage_UserAndMachineNotMatch: 150003,
    RemoveImage_MachineStillActivity: 150004,
    RemoveImage_RemoveImage_Failed: 150005,
    RemoveImage_FixedRental: 150006,

    RemoveImage_NoAccess: 150098,
    RemoveImage_InvalidStatus: 150099,

    //Rental Request 
    RentalRequest_PackageAvailable_Success: 160000,
    RentalRequest_PackageAvailable_Exception: 160001,
    RentalRequest_PackageAvailable_UserNotExist: 160002,
    RentalRequest_PackageAvailable_RequestNotificationMachine: 160003,

    RentalRequest_FixedRental_Success: 160100,
    RentalRequest_FixedRental_Exception: 160101,
    RentalRequest_FixedRental_UserNotExist: 160102,
    RentalRequest_FixedRental_InsertRentalRequest: 160103,
    RentalRequest_FixedRental_InsertRentalDetailsRequest: 160104,

    //Payment
    PaymentWithPaypal_Success: 170000,
    PaymentWithPaypal_Exception: 170001,
    PaymentWithPaypal_UserNotExist: 170002,
    PaymentWithPaypal_CheckAvailableMethod: 170003,
    PaymentWithPaypal_CheckAvailableMethod_NoData: 170004,
    PaymentWithPaypal_MethodNotAllowed: 170005,
    PaymentWithPaypal_LimitMinimumDeposit: 170006,
    PaymentWithPaypal_LimitMaximumDeposit: 170007,
    PaymentWithPaypal_CreateInvoice: 170008,

    PaymentWithStripe_Success: 170100,
    PaymentWithStripe_Exception: 171001,
    PaymentWithStripe_UserNotExist: 170102,
    PaymentWithStripe_CheckAvailableMethod: 170103,
    PaymentWithStripe_CheckAvailableMethod_NoData: 170104,
    PaymentWithStripe_MethodNotAllowed: 170105,
    PaymentWithStripe_LimitMinimumDeposit: 170106,
    PaymentWithStripe_LimitMaximumDeposit: 170107,
    PaymentWithStripe_CreateInvoice: 170107,

    PaymentWithNganLuong_Success: 170200,
    PaymentWithNganLuong_Exception: 170201,
    PaymentWithNganLuong_UserNotExist: 170202,
    PaymentWithNganLuong_CheckAvailableMethod: 170203,
    PaymentWithNganLuong_CheckAvailableMethod_NoData: 170204,
    PaymentWithNganLuong_MethodNotAllowed: 170205,
    PaymentWithNganLuong_LimitMinimumDeposit: 170206,
    PaymentWithNganLuong_LimitMaximumDeposit: 170207,
    PaymentWithNganLuong_CreateInvoice: 170207,

    PaymentWithMoMo_Success: 170300,
    PaymentWithMoMo_Exception: 170301,
    PaymentWithMoMo_UserNotExist: 170302,
    PaymentWithMoMo_CheckAvailableMethod: 170303,
    PaymentWithMoMo_CheckAvailableMethod_NoData: 170304,
    PaymentWithMoMo_MethodNotAllowed: 170305,
    PaymentWithMoMo_LimitMinimumDeposit: 170306,
    PaymentWithMoMo_LimitMaximumDeposit: 170307,
    PaymentWithMoMo_CreateInvoice: 170308,
    PaymentWithMoMo_RequestToMoMoFailed: 170309,

    //Fixed rental create
    FixedRentalCreate_UserIdNotFound: -180000,
    FixedRentalCreate_UserInformationView_Failed: -180001, //User_UserInformationView
    FixedRentalCreate_UserInformationView_NoData: -180002,
    FixedRentalCreate_CheckAccess_Failed: -180005, //User_CheckAccess  

    FixedRentalCreate_Success: 180000,
    FixedRentalCreate_Exception: 180001,
    FixedRentalCreate_UserNotExist: 180002,
    FixedRentalCreate_BalanceNotEnough: 180003,
    FixedRentalCreate_GetPrice_Failed: 180004,
    FixedRentalCreate_GetPrice_NoData: 180005,
    FixedRentalCreate_BalanceNotEnoughFixedRental: 180006,
    FixedRentalCreate_GetAllServerReport_Failed: 180007,
    FixedRentalCreate_GetAllServerReport_NoData: 180008,
    FixedRentalCreate_MachineNotAvailable: 180009,
    FixedRentalCreate_UpdateBalanceByUserId_Failed: 180010,
    FixedRentalCreate_InsertBilling_Failed: 180011,
    FixedRentalCreate_InsertFixedRental_Failed: 180012,
    FixedRentalCreate_CreateNewFixedRentalMachine_Failed: 180013,

    FixedRentalCreate_NoAccess: 180098,

    //Create machine fixed rental 
    CreateImageFixedRental_UserIdNotFound: -190000,
    CreateImageFixedRental_UserInformationView_Failed: -190001, //User_UserInformationView
    CreateImageFixedRental_UserInformationView_NoData: -190002,
    CreateImageFixedRental_CheckAccess_Failed: -190005, //User_CheckAccess  

    CreateImageFixedRental_Success: 190000,
    CreateImageFixedRental_Exception: 190001,
    CreateImageFixedRental_UserNotExist: 190002,
    CreateImageFixedRental_BalanceNotEnough: 190003,
    CreateImageFixedRental_GetPrice_Failed: 190004,
    CreateImageFixedRental_GetPrice_NoData: 190005,
    CreateImageFixedRental_BalanceNotEnoughFixedRental: 190006,
    CreateImageFixedRental_GetAllServerReport_Failed: 190007,
    CreateImageFixedRental_GetAllServerReport_NoData: 190008,
    CreateImageFixedRental_MachineNotAvailable: 190009,
    CreateImageFixedRental_CreateFixedRental_Failed: 190010,

    CreateImageFixedRental_NoAccess: 190098,

    FixedRentalRenewal_UserIdNotFound: -200000,
    FixedRentalRenewal_UserInformationView_Failed: -200001, //User_UserInformationViewByUserId
    FixedRentalRenewal_UserInformationView_NoData: -200002,
    FixedRentalRenewal_CheckAccess_Failed: -200005, //User_CheckAccess

    FixedRentalRenewal_Success: 200000,
    FixedRentalRenewal_Exception: 200001,
    FixedRentalRenewal_FixedRentalView_Failed: 200002,
    FixedRentalRenewal_FixedRentalView_NoData: 200003,
    FixedRentalRenewal_FixedRentalDetailsView_Failed: 200004,
    FixedRentalRenewal_FixedRentalDetailsView_NoData: 200005,
    FixedRentalRenewal_GetPrice_Failed: 200006,
    FixedRentalRenewal_GetPrice_NoData: 200007,
    FixedRentalRenewal_BalanceNotEnoughFixedRental: 200008,
    FixedRentalRenewal_GetAllServerReport_Failed: 200009,
    FixedRentalRenewal_GetAllServerReport_NoData: 200010,
    FixedRentalRenewal_MachineNotAvailable: 200011,
    FixedRentalRenewal_FixedRentalExtend_Failed: 200012,

    //Fixed rental deactivate 
    FixedRentalDeactivate_UserIdNotFound: -210000,
    FixedRentalDeactivate_UserInformationView_Failed: -210001, //User_UserInformationViewByUserId
    FixedRentalDeactivate_UserInformationView_NoData: -210002,
    FixedRentalDeactivate_CheckAccess_Failed: -210005, //User_CheckAccess

    FixedRentalDeactivate_Success: 210000,
    FixedRentalDeactivate_Exception: 210001,
    FixedRentalDeactivate_FixedRentalDeactivate_Failed: 210003,








    UnknownError: 1000,
    InvalidInfo: 1001,

    Wallet_GetUserRentalWallet_Success: 5000,
    Wallet_GetUserRentalWallet_Failed: 5001,

    Rental_UserNotExist: 7000,
    Rental_LimitedImage: 7001,
    Rental_CantGetWallet: 7002,
    Rental_MachineNotExist: 7003,
    Rental_BalanceNotEnough: 7004,
    Rental_UserAndMachineMismatched: 7005,

    ListMachine_Success: 8000,

    ListServicePack_Success: 10000,

    GetProfile_Success: 14000,
    GetProfile_Failed: 14001,

    Payment_GetIrenderPoint_Success: 19000,
    Payment_GetIrenderPoint_Failed: 19001,

    Wallet_GetTempBalanceUser_Success: 20000,

    Cancel_Success: 21000,

    GetPaymentPolicy_Success: 22000,

    GetParameter_Success: 23000,

    GetMasterList_Success: 24000,

    RequestImage_Success: 25000,
    RequestImage_LimitedMinimumBalanceToRequest: 25001,

    DashboardGetInformationMachine_Success: 26000,
    DashboardGetInformationBilling_Success: 26001,

    GetAllServerReport_Success: 27000,

    ResetMachine_Success: 28000,

    GetCategoryList_Success: 29000,

    GetSoftwareList_Success: 30000,

    Payment_Pay_Success: 31000,
    Payment_LimitMinimumAmount: 31001,
    Payment_LimitMaximumAmount: 31002,
    Payment_MethodNotEnabled: 31003,

    GetBasicUserInformation_Success: 32000,

    ReSendEmail_Success: 33000,
    ReSendEmail_Failed: 33001,
    ReSendEmail_AccountHadActive: 33002,

    GetUserConfiguration_Success: 35000,

    PreBootMachine_Success: 36000,

    RequestNotificationMachine_Success: 38000,

    Storage_GetUserStorageInfoZ_Success: 39000,
    Storage_GetUserStorageInfoZ_Failed: 39001,

    CountNumberMachine_Success: 40000,

    Validate_Token_Gpuhub_Sync_Fail: 41001,

    Get_time_UTC: 42001,

    PreCreateImage_CanCreate: 43000,
    PreCreateImage_BalanceLessThanZero: 43001,
    PreCreateImage_BalanceUnavailable: 43002,
    PreCreateImage_MachineUnavailable: 43003,

    GetPackageChangeList_Success: 44000,

    MachineListView_Success: 45000,

    RentalRequest_FixedRental_Success: 46000,

    EnableTwoFactorAuth_Success: 61000,
    EnableTwoFactorAuth_PinInvalid: 61001,
    EnableTwoFactorAuth_Failed: 61002,
};

/*eslint-enable */

export const authServiceConfig = {
    loginUrl: `${environment.API_HOST}/api/auth/authenticate`,
    changePasswordUrl: `${environment.API_HOST}/api/auth/change-password`,
    getBasicUserInformationUrl: `${environment.API_HOST}/api/auth/get-basic-user-information`,
    registerUserUrl: `${environment.API_HOST}/api/auth/register`,
    forgotPasswordSubmitUrl: `${environment.API_HOST}/api/auth/forgot-password`,
    getProfileUserUrl: `${environment.API_HOST}/api/auth/user-profile`,
    updateProfileUserUrl: `${environment.API_HOST}/api/auth/update-profile`,
    getTempBalanceUrl: `${environment.API_HOST}/api/auth/get-temp-balance-user`,
    logoutUrl: `${environment.API_HOST}/api/auth/logout`,
    getParameterByTypeUrl: `${environment.API_HOST}/api/auth/get-params-by-type/{0}`,
    getDashboardInformationMachineUrl: `${environment.API_HOST}/api/auth/get-dashboard-information-machine`,
    getDashboardInformationBillingUrl: `${environment.API_HOST}/api/auth/get-dashboard-information-billing/{0}`,
    reSendEmail: `${environment.API_HOST}/api/auth/resent-active-email`,
    reActivateAccount: `${environment.API_HOST}/api/auth/reactivate-account`,
    retryUserInfomations: `${environment.API_HOST}/api/auth/reactivate-account-retry-user-infomation`,
    reActivateAccountVerifyV2: `${environment.API_HOST}/api/auth/reactivate-account-verify-v2`,
    getIpInfoUrl: `${environment.API_HOST}/api/auth/get-ip-info`,

    getEnableTfaInfoUrl: `${environment.API_HOST}/api/auth/get-enable-tfa-info`,
    postEnableTfaUrl: `${environment.API_HOST}/api/auth/post-enable-tfa`,
    postDisableTfaUrl: `${environment.API_HOST}/api/auth/post-disable-tfa`,
    getIsEnableTfaInfoUrl: `${environment.API_HOST}/api/auth/get-is-enable-tfa-info`,
};

export const irenderRentalConfig = {
    getServicePackListUrl: `${environment.API_HOST}/api/rental/get-service-pack-list`,
    getOperatingSystemListUrl: `${environment.API_HOST}/api/rental/operating-system-list-view`,
    getCategoryListUrl: `${environment.API_HOST}/api/rental/get-category-list`,
    getMasterListUrl: `${environment.API_HOST}/api/rental/get-master-list/{0}/{1}/{2}`,
    getSoftwareListUrl: `${environment.API_HOST}/api/rental/get-software-list/{0}`,
    createMachineUrl: `${environment.API_HOST}/api/rental/create-image`,
    createImageFixedRentalUrl: `${environment.API_HOST}/api/rental/create-image-fixed-rental`,
    downloadMachineUrl: `${environment.API_HOST}/api/rental/download-remote-desktop/`,
    requestImageUrl: `${environment.API_HOST}/api/rental/request-image`,
    getAvailabilityServiceUrl: `${environment.API_HOST}/api/rental/get-availability-service`,
    changeServicePackageUrl: `${environment.API_HOST}/api/rental/change-service-package`,
    countNumberMachineUrl: `${environment.API_HOST}/api/rental/count-number-machine`,
    getServicePackageUrl: `${environment.API_HOST}/api/rental/get-service-package`,
    preCreateImageUrl: `${environment.API_HOST}/api/rental/pre-create-image`,
    getPackageChangeListUrl: `${environment.API_HOST}/api/rental/get-service-package-change-list`,
    getPriceUrl: `${environment.API_HOST}/api/rental/get-price`,
    rentalRequestViewUrl: `${environment.API_HOST}/api/rental/rental-request-view`,
    fixedRentalViewUrl: `${environment.API_HOST}/api/rental/fixed-rental-view`,
    deactivateFixedRentalUrl: `${environment.API_HOST}/api/rental/fixed-rental-deactivate`,
    fixedRentalSettingsUrl: `${environment.API_HOST}/api/rental/fixed-rental-settings`,
    serverReportViewUrl: `${environment.API_HOST}/api/rental/server-report-view`,
    serverReportDelayedViewUrl: `${environment.API_HOST}/api/rental/server-report-view-delayed`,
};


export const paymentApiConfig = {
    backendHostUrl: `${environment.API_HOST}/`,
    getIrenderPoint: `${environment.API_HOST}/api/payment/get-irender-point`,
    getPaymentPolicyUrl: `${environment.API_HOST}/api/payment/get-recharge-policy`,
    getListBillingUrl: `${environment.API_HOST}/api/billing/get-billing`,
    getListTransactionUrl: `${environment.API_HOST}/api/transaction-history`,
    payWidthPaypalUrl: `${environment.API_HOST}/api/payment/pay-with-paypal`,
    payWidthNganLuongUrl: `${environment.API_HOST}/api/payment/pay-with-ngan-luong`,
    payWidthCreditCardUrl: `${environment.API_HOST}/api/payment/pay-with-stripe`,
    payMoMoUrl: `${environment.API_HOST}/api/payment/pay-with-momo`,
    payWidthAdyenUrl: `${environment.API_HOST}/api/payment/pay-with-adyen`,
    applyCouponUrl: `${environment.API_HOST}/api/payment/apply-coupon`,

    createPaymentUrl: `${environment.API_HOST}/api/payment/create-payment`,
    promotionViewUrl: `${environment.API_HOST}/api/payment/promotion-basic-view`,
    paymentCalculateUrl: `${environment.API_HOST}/api/payment/payment-calculate`,
}

export const billingApiConfig = {
    getBillingHistoryUrl: `${environment.API_HOST}/api/billing/billing-history`,
}

export const transactionApiConfig = {
    getTransactionHistoryUrl: `${environment.API_HOST}/api/transaction/transaction-history`,
}

export const chatHistoryApiConfig = {
    getChatHistoryUrl: `${environment.API_HOST}/api/chat-history/get-chat-history`,
}

export const masterDataApiConfig = {
    getPromotionBannerView: `${environment.API_HOST}/api/master/get-promotion-banners-view`,
}

export const stakingApiConfig = {
    getActiveCampaign: `${environment.API_HOST}/api/staking-point/get-staking-point-campaign`,
    getActivePolicy: `${environment.API_HOST}/api/staking-point/get-staking-point-policy`,
    getActiveTime: `${environment.API_HOST}/api/staking-point/get-staking-time`,
    getTransactionOfCampaign: `${environment.API_HOST}/api/staking-point/get-staking-transaction-by-cp`,
    getTransactionOfUser: `${environment.API_HOST}/api/staking-point/get-staking-transction-by-user`,
    getDetailTransaction: `${environment.API_HOST}/api/staking-point/get-staking-detail-transaction`,
    stakeTransaction: `${environment.API_HOST}/api/staking-point/stake-transaction`,
    unstakeTransaction: `${environment.API_HOST}/api/staking-point/unstake-transaction`,
    getBalance: `${environment.API_HOST}/api/staking-point/get-staking-balance`,
}